<script setup lang="ts">
import { ref, computed } from 'vue';
import { UiText, UiButton } from '@shopexperts/shared';
import TabNav from '@/components/TabNav.vue';
import RequestReviewAside from '@/app/components/reviews/RequestReviewAside.vue';
import ReviewStatsGrid from '@/app/components/reviews/ReviewStatsGrid.vue';
import ExpertPublishedReviews from '@/app/pages/expert-reviews/ExpertPublishedReviews.vue';
import ExpertInvitedList from '@/app/pages/expert-reviews/ExpertInvitedList.vue';
import { useExpertReviews } from '@/app/composables/reviews/useExpertReviews';

const asideOpen = ref(false);
const { stats } = useExpertReviews();

const totalReviews = computed(() => stats.value?.total_published || 0);

const tabs = [
    { value: 'your-reviews', label: 'Your Reviews', component: ExpertPublishedReviews },
    { value: 'invited-list', label: 'Invited List', component: ExpertInvitedList },
    { value: 'widgets', label: 'Widgets', component: ExpertInvitedList, isDisabled: true },
];
</script>

<template>
    <main class="flex-1 p-6 overflow-y-auto bg-secondary font-light">
        <div class="flex flex-col md:flex-row items-stretch md:items-start mb-6 justify-between gap-6 md:gap-4">
            <div>
                <div class="flex items-center">
                    <UiText as="h1" variant="h3" class="mb-2" :text="`Reviews`" />
                    <UiText as="span" variant="span" :text="`(${totalReviews})`" class="text-se-gray-700" />
                </div>
                <UiText as="p" variant="p" class="mt-1 text-gray-600">
                    Encourage past clients to share their feedback. Positive reviews and testimonials<br>are powerful
                    social proof that can boost your profile's attractiveness.
                </UiText>
            </div>

            <UiButton
                variant="primary"
                label="Request a Review"
                show-arrow
                @click="asideOpen = true">
            </UiButton>
        </div>

        <ReviewStatsGrid :stats="stats" />

        <TabNav :tabs="tabs" />

        <RequestReviewAside v-model:open="asideOpen" />
    </main>
</template>
